import type { AuthUserFieldsFragment } from '~/graphql/generated/graphql';

export const AuthState = {
  Anonymous: 'anonymous',
  Ghost: 'ghost',
  Student: 'student',
  Teacher: 'teacher',
  Admin: 'admin',
} as const;

// eslint-disable-next-line ts/no-redeclare
export type AuthState = (typeof AuthState)[keyof typeof AuthState];

/**
 * A user holding several roles is reported as the most privileged one. A user with no role at all is a ghost,
 * because ghosts are the only users minted without a role (`UserService::createGhostStudent`).
 */
export const authStateFor = (user: AuthUserFieldsFragment | null | undefined): AuthState => {
  if (!user) {
    return AuthState.Anonymous;
  }
  if (user.adminRoles.length > 0) {
    return AuthState.Admin;
  }
  if (user.teacherRoles.length > 0) {
    return AuthState.Teacher;
  }
  if (user.studentRoles.length > 0) {
    return AuthState.Student;
  }

  return AuthState.Ghost;
};
